import { Box, ButtonBase, Skeleton, Typography } from '@mui/material';
import GroupOutlinedIcon from '@mui/icons-material/GroupOutlined';
import useTemplateSx from '../../hooks/useTemplateSx';
import { radiusPx } from '../../../../theme/tokens';

export default function OptinUsersTabButton({
  active = false,
  count,
  isLoading = false,
  onClick,
}) {
  const styles = useTemplateSx();

  return (
    <ButtonBase
      onClick={onClick}
      aria-pressed={active}
      aria-label="Optin Users"
      sx={{...styles.optinUsersTabButton(active), borderRadius:radiusPx.md}}
    >
      <GroupOutlinedIcon sx={styles.optinUsersTabIcon(active)} fontSize="small" />
      <Typography component="span" sx={styles.optinUsersTabLabel(active)}>
        Optin Users
      </Typography>
      {/* {isLoading ? (
        <Skeleton variant="rounded" width={28} height={18} sx={{ borderRadius: 999 }} />
      ) : (
        <Box component="span" sx={styles.optinUsersTabBadge(active)}>
          {count ?? 0}
        </Box>
      )} */}
    </ButtonBase>
  );
}
